import { T } from '@tribeplatform/react-components/i18n'
import type { I18nShape } from '@tribeplatform/react-components/i18n'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { TreeItems } from '../types.js'

export const LOADING_INDEX = 'loading'

export const createLoadingTreeItem = ({ $t }: I18nShape): TreeItems => ({
  [LOADING_INDEX]: {
    index: LOADING_INDEX,
    isFolder: false,
    data: {
      type: 'simple',
      title: $t({
        id: 'Generics.LoadingDotDotDot',
        defaultMessage: 'Loading...',
      }) as string,
      render: () => (
        <div className="flex items-center gap-2 text-sm text-content-subdued">
          <SvgIcon name="spinner" className="animate-spin" />
          <T id="Generics.LoadingDotDotDot" defaultMessage="Loading..." />
        </div>
      ),
    },
  },
})
